import { ApolloCache } from '@apollo/client';

import {
  CreateSearchAlertMutationResult,
  DeleteSearchAlertMutationResult,
  SearchAlertFragment,
  VisitSearchAlertMutationResult,
} from '@/graphql/generated';

export const deleteAlertFromCache =
  (alertId: string, userId?: string) =>
  (cache: ApolloCache<unknown>, { data }: DeleteSearchAlertMutationResult) => {
    if (data?.deleteSearchAlert?.__typename === 'Empty') {
      cache.modify({
        id: cache.identify({ __typename: 'Viewer', id: userId }),
        fields: {
          searchAlerts: (existingAlerts) => ({
            ...existingAlerts,
            collection: existingAlerts.collection.filter((alert: SearchAlertFragment) => alertId !== alert.id),
          }),
        },
      });
    }
  };

export const addAlertToCachedList =
  (userId?: string) =>
  (cache: ApolloCache<unknown>, { data }: CreateSearchAlertMutationResult) => {
    if (userId && data?.createSearchAlert?.__typename === 'SearchAlertCreationSuccess') {
      const viewerId = cache.identify({ __typename: 'Viewer', id: userId });
      const alert = data.createSearchAlert.alert;

      cache.modify({
        id: viewerId,
        fields: {
          searchAlerts: (existingAlerts) => ({
            ...existingAlerts,
            collection: [alert, ...existingAlerts.collection],
          }),
        },
      });
    }
  };

export const zeroifySearchAlertsNewJobCount =
  (alertId: string, userId?: string) =>
  (cache: ApolloCache<unknown>, { data }: VisitSearchAlertMutationResult) => {
    if (data?.visitSearchAlert?.__typename === 'Empty') {
      cache.modify({
        id: cache.identify({ __typename: 'Viewer', id: userId }),
        fields: {
          searchAlerts: (existingAlerts) => ({
            ...existingAlerts,
            collection: existingAlerts.collection.map((alert) =>
              alert.id === alertId ? { ...alert, newJobCount: 0 } : alert
            ),
          }),
        },
      });
    }
  };
